<app-crear-editar [loading]="!form" [title]="title" icono="route">
  @if (form) {
    <form
      id="form-recorrido"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <!-- Datos básicos -->
      <app-content-card title="Datos básicos" icon="info">
        <section class="inputs-group">
          <mat-form-field class="campo">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="nombre" />
            <mat-icon matPrefix>label</mat-icon>
          </mat-form-field>

          <mat-form-field class="campo">
            <mat-label>Color</mat-label>
            <input matInput readonly formControlName="color" />
            <ngx-colors
              class="suffix"
              matSuffix
              ngx-colors-trigger
              formControlName="color"
              (change)="onColorChange($event, 'color')"
            ></ngx-colors>
          </mat-form-field>
        </section>

        <section class="inputs-group">
          <mat-form-field class="campo">
            <mat-label>Duración</mat-label>
            <input matInput formControlName="duracion" />
            <mat-icon matPrefix>timer</mat-icon>
            <span matTextSuffix>min</span>
          </mat-form-field>

          <mat-form-field class="campo">
            <mat-label>Identificación Externa</mat-label>
            <input matInput formControlName="idExterno" />
            <mat-icon matPrefix>tag</mat-icon>
          </mat-form-field>
        </section>
      </app-content-card>

      <!-- Línea y terminales -->
      <app-content-card title="Línea y terminales" icon="directions_bus">
        <section class="inputs-group">
          <div class="campo-con-boton">
            <ng-select
              [items]="grupos"
              bindLabel="nombre"
              bindValue="_id"
              formControlName="idGrupo"
              placeholder="Línea"
              notFoundText="Sin resultados"
              appendTo="body"
              (change)="onGrupoChange($event)"
            ></ng-select>
            <app-button
              matType="mat-fab"
              color="primary"
              icon="add"
              [tooltip]="'Crear línea'"
              (click)="crearGrupo()"
            ></app-button>
          </div>

          <div class="campo-con-boton">
            <ng-select
              [items]="terminales"
              bindLabel="identificacion"
              bindValue="_id"
              formControlName="idsUbicaciones"
              placeholder="Terminales"
              notFoundText="Sin resultados"
              appendTo="body"
              [multiple]="true"
              [closeOnSelect]="false"
              (change)="onTerminalesChange($event)"
            ></ng-select>
            <app-button
              matType="mat-fab"
              color="primary"
              icon="add"
              [tooltip]="'Crear terminal'"
              (click)="crearTerminal()"
            ></app-button>
          </div>
        </section>

        <section class="inputs-group">
          <mat-form-field class="campo">
            <mat-label>Destino</mat-label>
            <input matInput formControlName="destino" />
            <mat-icon matPrefix>flag</mat-icon>
          </mat-form-field>

          <mat-form-field class="campo">
            <mat-label>Por</mat-label>
            <input matInput formControlName="por" />
            <mat-icon matPrefix>alt_route</mat-icon>
          </mat-form-field>
        </section>
      </app-content-card>

      <!-- Trazado y paradas -->
      <app-content-card title="Trazado y paradas" icon="map">
        <div class="mapa-recorrido">
          <app-mapa-paradas-mapbox
            [formulario]="form"
            [terminales]="terminalesSeleccionadas"
          ></app-mapa-paradas-mapbox>
        </div>
      </app-content-card>

      <!-- Franjas horarias -->
      <app-content-card title="Franjas horarias" icon="schedule">
        <div class="franjas" formArrayName="franjaHoraria">
          @if (franjaHoraria.controls.length) {
            <div class="franja franja-encabezado">
              <span>Día</span>
              <span>Desde</span>
              <span>Hasta</span>
              <span>Frecuencia</span>
              <span></span>
            </div>
          }

          @for (f of franjaHoraria.controls; track f; let i = $index) {
            <div class="franja" [formGroupName]="i">
              <ng-select
                formControlName="dia"
                placeholder="Día"
                [items]="opcionesDia"
                bindValue="valor"
                bindLabel="etiqueta"
                appendTo="body"
                notFoundText="Sin resultados"
              ></ng-select>

              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Desde</mat-label>
                <input
                  matInput
                  [owlDateTime]="dt1"
                  formControlName="desde"
                  [disabled]="true"
                />
                <button
                  irxBotonIcono
                  tooltip="Elegir hora"
                  matSuffix
                  [owlDateTimeTrigger]="dt1"
                  type="button"
                >
                  <mat-icon>schedule</mat-icon>
                </button>
                <owl-date-time
                  [pickerType]="'timer'"
                  [startAt]="hoyALas0"
                  #dt1
                ></owl-date-time>
              </mat-form-field>

              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Hasta</mat-label>
                <input
                  matInput
                  [owlDateTime]="dt2"
                  formControlName="hasta"
                  [disabled]="true"
                />
                <button
                  irxBotonIcono
                  tooltip="Elegir hora"
                  matSuffix
                  [owlDateTimeTrigger]="dt2"
                  type="button"
                >
                  <mat-icon>schedule</mat-icon>
                </button>
                <owl-date-time
                  [pickerType]="'timer'"
                  [startAt]="hoyALas0"
                  #dt2
                ></owl-date-time>
              </mat-form-field>

              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Frecuencia</mat-label>
                <input
                  matInput
                  placeholder="15"
                  formControlName="frecuenciaMinutos"
                  type="number"
                />
                <span matTextSuffix>min</span>
              </mat-form-field>

              <button
                irxBotonIcono
                type="button"
                class="franja-eliminar"
                tooltip="Eliminar franja"
                (click)="deleteFranja(i)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          } @empty {
            <span class="no-info">Sin franjas horarias</span>
          }

          <div>
            <button irxBoton="secundario" type="button" (click)="addFranja()">
              <mat-icon>add</mat-icon>
              Agregar franja horaria
            </button>
          </div>
        </div>
      </app-content-card>
    </form>
  }

  <ng-container actions>
    <button irxBoton="secundario" type="button" (click)="volver()">
      Cancelar
    </button>
    <button
      irxBoton="principal"
      type="submit"
      form="form-recorrido"
      [disabled]="!form?.valid || loading"
    >
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </ng-container>
</app-crear-editar>
